import { createContext, useContext } from 'react';

const FormContext = createContext(null);
export default FormContext;
export const useFormContext = () => useContext(FormContext);
